module.exports = __webpack_public_path__ + "img/has-red.2fe77d09.png";